import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import './Auth.css';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!supabase) {
      setError('Sovellus ei ole konfiguroitu. Tarkista ympäristömuuttujat.');
      setLoading(false);
      return;
    }

    // Debug: loggaa Supabase-arvot (vain dev)
    if (process.env.NODE_ENV !== 'production') {
      const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
      const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
      console.log('Login: Supabase URL:', supabaseUrl);
      console.log('Login: Supabase Anon Key:', anonKey ? `${anonKey.substring(0, 20)}...` : 'MISSING');
    }

    try {
      const { error: signInError } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (signInError) {
        setError(signInError.message || 'Kirjautuminen epäonnistui.');
        setLoading(false);
        return;
      }

      // Tarkista onko birth_data olemassa
      const { data: { user: currentUser } } = await supabase.auth.getUser();
      if (currentUser) {
        const { data: birthData } = await supabase
          .from('birth_data')
          .select('user_id')
          .eq('user_id', currentUser.id)
          .maybeSingle();

        if (birthData) {
          // Birth data löytyy -> dashboard
          navigate('/dashboard');
        } else {
          // Birth data puuttuu -> welcome
          navigate('/welcome');
        }
      } else {
        navigate('/welcome');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Kirjautuminen epäonnistui. Yritä uudelleen.');
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Kirjaudu</h1>
        {error && <div className="auth-error">{error}</div>}
        
        <form onSubmit={handleLogin}>
          <label htmlFor="email">Sähköposti</label>
          <input
            id="email"
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="sähköposti@esim.fi"
            required
          />

          <label htmlFor="password">Salasana</label>
          <input
            id="password"
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />

          <button type="submit" disabled={loading} className="auth-button">
            {loading ? 'Kirjaudutaan...' : 'Kirjaudu'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
